import type { ReactNode } from "react";
import type { Territoire } from "models";
import { Link, Skeleton } from "@mui/material";
import { COLLECTIVITES_APP_DOMAIN_NAME } from "config/app-config";

interface TerritoireLinkProps {
  territoire: Territoire;
  isLoading?: boolean;
}

export function TerritoireLink({
  territoire,
  isLoading = false,
}: Readonly<TerritoireLinkProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Link
      target="_blank"
      href={`https://${COLLECTIVITES_APP_DOMAIN_NAME}/territoire/${territoire.id}`}>
      {territoire.libelle.replace("Territoire ", "")}
    </Link>
  );
}
